import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { ChakraProvider } from "@chakra-ui/react";
import {
  injectedWallet,
  braveWallet,
  coinbaseWallet,
  metaMaskWallet,
  trustWallet,
  uniswapWallet,
} from "@rainbow-me/rainbowkit/wallets";
import "@rainbow-me/rainbowkit/styles.css";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import {
  connectorsForWallets,
  lightTheme,
  RainbowKitProvider,
} from "@rainbow-me/rainbowkit";
import { getDefaultConfig } from '@rainbow-me/rainbowkit';

import { WagmiConfig, createConfig } from "wagmi";
import { http, fallback, webSocket } from "viem";
import { arbitrum } from "wagmi/chains";
import App from "./App";

// ✅ Safety checks
if (typeof window === "undefined") {
  console.error("No browser environment detected.");
  throw new Error("No browser environment detected.");
}
if (!("WebSocket" in window)) {
  console.error("WebSocket not supported in this browser.");
}

const queryClient = new QueryClient();


// ✅ WebSocket fallback logic
const wsUrls = [
  process.env.REACT_APP_ALCHEMY_WS,
  process.env.REACT_APP_ALCHEMY_WS2,
  process.env.REACT_APP_INFURA_WS,
  process.env.REACT_APP_INFURA_WS2,
  process.env.REACT_APP_CHAINSTACK_WS,
  process.env.REACT_APP_CHAINSTACK_WS2,
  process.env.REACT_APP_QUICKNODE_WS,
  process.env.REACT_APP_QUICKNODE_WS2,
  process.env.REACT_APP_GETBLOCK_WS,
  process.env.REACT_APP_GETBLOCK_WS2,
  process.env.REACT_APP_BLASTAPI_WS,
  process.env.REACT_APP_BLASTAPI_WS2,
  process.env.REACT_APP_LAVA_WS,
];

function getFirstWorkingWebSocketTransport(urls) {
  for (const url of urls) {
    if (url && typeof url === "string") {
      try {
        console.log("✅ Trying WebSocket:", url);
        return webSocket(url);
      } catch (e) {
        console.warn("❌ WebSocket failed:", url, e);
      }
    }
  }
  throw new Error("No valid WebSocket URL found.");
}

//const projectId = "";
const projectId = process.env.REACT_APP_PROJECT_ID;
if (!projectId) throw new Error("Missing REACT_APP_PROJECT_ID in .env");




const config = getDefaultConfig({
  appName: 'BLINDFOLD',
  projectId: process.env.REACT_APP_PROJECT_ID,
  chains: [arbitrum],
  transports: {
    [arbitrum.id]: fallback([
      http(`https://arb-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_KEY}`),
      http(`https://arbitrum-mainnet.infura.io/v3/${process.env.REACT_APP_INFURA_KEY}`),
      http('https://arb1.arbitrum.io/rpc'),
    ]),
  },
  ssr: false,
});

// ✅ Error boundary
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught:", error, errorInfo);
  }

  render() {
    return this.state.hasError ? (
      <h1>Something went wrong. Try refreshing.</h1>
    ) : (
      this.props.children
    );
  }
}

// ✅ Mount app
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
    <QueryClientProvider client={queryClient}>

      <WagmiConfig config={config}>
        <RainbowKitProvider
           chains ={[arbitrum]}
          theme={lightTheme({
            accentColor: "#0052ff",
            accentColorForeground: "white",
            borderRadius: "large",
            fontStack: "system",
          })}
        >
          <ChakraProvider>
            <App />
          </ChakraProvider>
        </RainbowKitProvider>
      </WagmiConfig>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
